const MercedesBenz = [
    {
        ID: "mercedes_1",
        name: "Maybach S560 ",
        brand: "Mercedes Benz",
        price: 11.1,
        engine: "V8 Twin Turbo",
        max: 250,
        version: "9G-TRONIC",
        type: "Sedan",
        avatar: "https://i.ibb.co/y66MWs9/s560.webp",
        link: "/brands/mercedes-benz/maybach-s560",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
];
export default MercedesBenz;
